import { Component, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'app-terms-of-use',
    templateUrl: './terms-of-use.component.html',
    styleUrls: ['./terms-of-use.component.scss'],
    encapsulation: ViewEncapsulation?.None,
    standalone: false
})
export class TermsOfUseComponent {



}
